import IFACE, { AbstractMethodError, EL, MissingContainerError, RecursionLimitError } from './IFACE.js';
import Activate from '../event/Activate.js';
import Deactivate from '../event/Deactivate.js';
import Flip from '../event/Flip.js';
/** An interface for Toggle driven Events for a switchable element */
export default class Switchable extends IFACE {
    /** A series of Switch Related Events and Methods
        @param {EL} node Class to implement this interface (Typically 'this')
        @param {[EL]} [callers] Optional array of caller elements that trigger this switchable element
    */
    constructor(node, callers = new Array()) {
        super(node, 'switch');
        node.getCallers().push(...callers);
        node.getCallers().forEach((caller) => {
            if (typeof caller !== 'undefined') {
                caller.on('activate', () => node.activate());
                caller.on('deactivate', () => node.deactivate());
                caller.on('flip', () => node.flip());
            }
        });
    }
    addListeners(node) {
        node.on('activate', () => node.activate());
        node.on('deactivate', () => node.deactivate());
        node.on('flip', () => node.flip());
    }
    setMethods(node) {
        /** Adds active state to node */
        //this.methods.activate = () => node.chain(() => node.addClass('active', !node.hasClass('active')));
        this.methods.activate = () => node.chain(() => {
            if (!node.hasClass('active')) {
                node.addClass('active');
            }
        });
        /** Removes active state from node */
        this.methods.deactivate = () => {
            if (node.hasClass('active')) {
                node.chain(() => {
                    node.get().filter((c) => c.hasClass('active')).forEach((c) => c.do(new Deactivate(c)));
                    node.removeClass('active');
                    try {
                        node.deactivateReference();
                    }
                    catch (e) {
                        if (!(e instanceof TypeError)) {
                            console.error(this.toString() + '.deactivateReference()', e);
                        }
                    }
                });
            }
        };
        /** 'Flipping' this switch toggles the 'active' state of this element, triggering an Activate/Deactivate Event
            param {string} className Existence of classname indicates on/off event to call
            param {Event} eventOn Event to call if class does not yet exist
            param {Event} eventOff Event to call if class already exists
            @returns {Promise<ThisType>} Promise Chain
        */
        this.methods.flip = () => this.toggle('active', new Activate(node), new Deactivate(node));
    }
}
export { AbstractMethodError, Activate, Deactivate, EL, Flip, IFACE, MissingContainerError, RecursionLimitError };
